export class OutputWebSocketMessage {
	constructor(
		public messageType: string,
		public data: any
	) {}
}
